import { render, staticRenderFns } from "./ManageUploads.vue?vue&type=template&id=1e0010be&"
import script from "./ManageUploads.vue?vue&type=script&lang=js&"
export * from "./ManageUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports